import React from 'react';
import { connect } from 'react-redux';
import { trimDate } from '../../helper';

function sameString(a, b) {
	if(a === b) {
		return true;
	} else if(typeof a === 'string' && typeof b === 'string') {
		return a.toLowerCase() === b.toLowerCase();
	}
	return false;
}

function sameAddress(a1, a2, ignoreName) {
	if(a1 === a2) {
		return true;
	} else if(!a1 || !a2) {
		return false;
	}
	const keys = ['address', 'address2', 'postalCode', 'city', 'country'];
	if(!ignoreName) {
		keys.push('name');
	}
	for(const key of keys) {
		if(!sameString(a1[key], a2[key])) {
			return false;
		}
	}
	return true;
}

function matchingComment(a, b) {
	const prefix = 'depotzending - shipment:';
	const startsA = a?.startsWith(prefix) ?? false;
	const startsB = b?.startsWith(prefix) ?? false;
	if(startsA && startsB) {
		const endA = a.lastIndexOf('shipment');
		const endB = b.lastIndexOf('shipment');
		return a.slice(0, endA) === b.slice(0, endB);
	}
	return startsA === startsB;
}

function filter(order, orders) {
	const date = trimDate(order.dateOverride);
	return orders.filter(o => {
		return order === o
			|| o.status === order.status
			&& trimDate(o.dateOverride) === date
			&& order.pickers.length === o.pickers.length && order.pickers.every(p => o.pickers.includes(p))
			&& (o.dropship && order.dropship
			|| o.customer.code === order.customer.code && o.dropship === order.dropship
			&& sameAddress(order.address, o.address, o.dropship && order.dropship && !o.splitByName && !order.splitByName))
			&& matchingComment(order.remarks, o.remarks);
	});
}

function filterDropship(order, orders) {
	const date = trimDate(order.dateOverride);
	return orders.filter(o => {
		return order === o
			|| o.customer.code === order.customer.code
			&& o.status === order.status
			&& trimDate(o.dateOverride) === date
			&& sameAddress(order.address, o.address, o.dropship && order.dropship && !o.splitByName && !order.splitByName)
			&& matchingComment(order.remarks, o.remarks);
	});
}

export function groupOrders(role, order, orders) {
	if(order.customer.code === '174164') {
		return [order];
	} else if(role === 'PACKAGER') {
		return filterDropship(order, filter(order, orders));
	} else if(['PICKER', 'TEAM_LEADER'].includes(role) && (order.dropship || order.pickers.length)) {
		return filter(order, orders);
	}
	return [order];
}

function AbcOrder({ orders, match, component: Child, person, ...props }) {
	const order = orders.find(({ _id }) => _id === match.params.plan);
	if(!order) {
		return null;
	}
	const abc = groupOrders(person.role, order, orders);
	return <Child order={order} person={person} abc={abc} {...props} />;
}

export default connect(({ orders, person, warehouse, locations }) => {
	return { orders, person, warehouse, locations };
})(AbcOrder);
